/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class MercadopagoAPI extends ApiClient {
  constructor() {
    super("mercadopago/payment_links", { accountScoped: true });
  }

  getByConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  createLink({ conversationId, dealId, amount, description, currency }) {
    return axios.post(this.url, {
      conversation_id: conversationId,
      deal_id: dealId,
      amount,
      description,
      currency,
    });
  }
}

export default new MercadopagoAPI();
